import { Directive, forwardRef, HostBinding } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yRole } from '../interfaces/a11y.interfaces';

import { A11yLabelDirective } from './a11y-label.directive';

@Directive({
  selector: '[khA11yGroup]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yGroupDirective) }]
})
export class A11yGroupDirective extends A11yLabelDirective implements A11yRole {
  @HostBinding('attr.role') public readonly role = 'group';
}
